import { Link } from "wouter";
import { EmptyState } from "../components/AsyncStates";

export function NotFoundPage() {
  return (
    <EmptyState
      title="Page not found"
      description="That page doesn't exist, or you don't have access to it."
      action={
        <Link to="/" className="button button--secondary">
          Back home
        </Link>
      }
    />
  );
}
